import React from "react";
import "../../styles/TechnologySlider.css";

const topTechnologies = [
  {
    name: "Html",
    image:
      "https://i.pinimg.com/736x/eb/02/9a/eb029a57eced26a978f58d3e4db48f71.jpg",
  },
  {
    name: "Css",
    image:
      "https://i.pinimg.com/736x/bf/2f/5b/bf2f5b9cd7fbe5a193141b39cc4a2460.jpg",
  },
  {
    name: "JavaScript",
    image:
      "https://i.pinimg.com/736x/85/51/e2/8551e2939759ccdfd6fb561c0cdc6de6.jpg",
  },
  {
    name: "Bootstrap",
    image:
      "https://i.pinimg.com/1200x/92/d6/60/92d660adb69ff63b4d133cda9592d848.jpg",
  },
  {
    name: "React Js",
    image:
      "https://i.pinimg.com/736x/25/f6/59/25f659abdd5e2a0fafdca20a151cde1b.jpg",
  },
  {
    name: "Nest Js",
    image:
      "https://invoidea.com/service08/assets/images/icons/next-js-tech-icon.webp",
  },
  {
    name: "Tailwind CSS",
    image:
      "https://i.pinimg.com/736x/7b/df/1e/7bdf1e16c7bedec90f0662eb2f9ca764.jpg",
  },

  {
    name: "Wordpress",
    image: "https://cdn.worldvectorlogo.com/logos/wordpress-icon-1.svg",
  },
  {
    name: "Shopify",
    image: "https://cdn.worldvectorlogo.com/logos/shopify.svg",
  },
  {
    name: "Woocommerce",
    image: "https://cdn.worldvectorlogo.com/logos/woocommerce.svg",
  },
  {
    name: "Figma",
    image:
      "https://i.pinimg.com/1200x/29/95/95/29959595fe22edde8408b060d3ac3d82.jpg",
  },
];

const bottomTechnologies = [
  {
    name: "Android",
    image: "https://cdn.worldvectorlogo.com/logos/android-logomark.svg",
  },
  {
    name: "Python",
    image: "https://cdn.worldvectorlogo.com/logos/python-5.svg",
  },
  {
    name: "MySQL",
    image: "https://invoidea.com/service08/assets/images/icons/mysql.svg",
  },
  {
    name: "MongoDB",
    image: "https://cdn.worldvectorlogo.com/logos/mongodb-icon-1.svg",
  },
  {
    name: "Github",
    image: "https://cdn.worldvectorlogo.com/logos/github-icon-1.svg",
  },
  {
    name: "Java",
    image:
      "https://i.pinimg.com/1200x/8d/0c/72/8d0c72f49aaa0a6a35d34c7b98035baa.jpg",
  },
];

export default function TechnologySlider() {
  return (
    <div className="technology-section">
      <div className="technology-header">
        <span>TECHNOLOGIES WE DO BEST</span>
        <h3>Empower Your Brand with Advanced Web Technologies</h3>
        <p>
          We build high-performance websites and scalable digital solutions
          using modern technologies that enhance user experience, improve
          functionality, and accelerate business growth.
        </p>
      </div>

      {/* TOP LEFT SLIDER */}
      <div className="slider-row">
        <div className="slider-track left-slide">
          {[...topTechnologies, ...topTechnologies].map((item, index) => (
            <div className="tech-card" key={index}>
              <img src={item.image} alt={item.name} />
              <h3>{item.name}</h3>
            </div>
          ))}
        </div>
      </div>
      <br />
      {/* BOTTOM RIGHT SLIDER */}
      <div className="slider-row">
        <div className="slider-track right-slide">
          {[...bottomTechnologies, ...bottomTechnologies].map((item, index) => (
            <div className="tech-card" key={index}>
              <img src={item.image} alt={item.name} />
              <h3>{item.name}</h3>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
